import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  TCheckoutSession,
  TCheckoutSessionData,
  TCheckoutSessionStartPayload,
  TCheckoutSessionState,
  TCheckoutSessionStep,
} from './checkoutSession.types';
import {
  clearCheckoutSessionFromStorage,
  createCheckoutSession,
  loadCheckoutSessionFromStorage,
  saveCheckoutSessionToStorage,
} from './checkoutSession.utils';

const initialState: TCheckoutSessionState = {
  session: loadCheckoutSessionFromStorage(),
};

const checkoutSessionSlice = createSlice({
  name: 'checkoutSession',
  initialState,
  reducers: {
    startCheckoutSession: (
      state,
      action: PayloadAction<TCheckoutSessionStartPayload>
    ) => {
      const nextSession = createCheckoutSession(action.payload.checkoutData);
      state.session = nextSession;
      saveCheckoutSessionToStorage(nextSession);
    },
    setCheckoutSession: (state, action: PayloadAction<TCheckoutSession>) => {
      state.session = action.payload;
      saveCheckoutSessionToStorage(action.payload);
    },
    updateCheckoutSessionData: (
      state,
      action: PayloadAction<Partial<TCheckoutSessionData>>
    ) => {
      if (!state.session) return;

      state.session.checkoutData = {
        ...state.session.checkoutData,
        ...action.payload,
      };
      saveCheckoutSessionToStorage(state.session);
    },
    updateCheckoutSessionStep: (
      state,
      action: PayloadAction<TCheckoutSessionStep>
    ) => {
      if (!state.session) return;
      state.session.checkoutData.currentStep = action.payload;
      saveCheckoutSessionToStorage(state.session);
    },
    clearCheckoutSession: (state) => {
      state.session = null;
      clearCheckoutSessionFromStorage();
    },
    getCheckoutSession: (state) => {
      state.session = loadCheckoutSessionFromStorage();
    },
  },
});

export const {
  startCheckoutSession,
  setCheckoutSession,
  updateCheckoutSessionData,
  updateCheckoutSessionStep,
  clearCheckoutSession,
  getCheckoutSession,
} = checkoutSessionSlice.actions;

export const checkoutSessionReducer = checkoutSessionSlice.reducer;
